import { Theme as AugmentedTheme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';
import React from 'react';
import { Box, KeyValue, Grid } from 'web-library';
import { useTranslation } from 'react-i18next';
import FormHeader from '../../../../components/form-items/FormHeader';

const useStyles = makeStyles()((theme) =>
({
  container: {
    paddingBottom: theme.spacing(2),
  },
}));

export interface PersonalDetailsProps {
  statutoryName?: string;
  nricFin?: string | null;
  citizenship?: string;
  schoolName?: string;
  indexNo?: string;
}

const PersonalDetails = ({
  statutoryName = '',
  nricFin = '',
  citizenship = '',
  schoolName = '',
  indexNo,
}: PersonalDetailsProps) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <Box className={classes.container}>
      <FormHeader title={t('components->>PersonalDetails.Candidate Details')} />

      <KeyValue
        id="candidateName"
        keyText={t('components->>PersonalDetails.Name')}
        valueText={statutoryName}
      />

      <Grid container direction="row">
        <Grid md={4} sm={12} xs={12}>
          <KeyValue
            id="nricFinPassport"
            keyText={t('components->>PersonalDetails.NRIC/FIN/Passport No.')}
            valueText={nricFin || ''}
          />
        </Grid>
        <Grid md={4} sm={12} xs={12}>
          <KeyValue
            id="citizenship"
            keyText={t('components->>PersonalDetails.Citizenship')}
            valueText={citizenship}
          />
        </Grid>
      </Grid>

      <Grid container direction="row">
        <Grid md={4} sm={12} xs={12}>
          <KeyValue
            id="school"
            keyText={t('components->>PersonalDetails.Exam Centre/School')}
            valueText={schoolName}
          />
        </Grid>
        {indexNo && (
          <Grid md={4} sm={12} xs={12}>
            <KeyValue
              id="indexNo"
              keyText={t('components->>PersonalDetails.Index No.')}
              valueText={indexNo}
            />
          </Grid>
        )}
      </Grid>
    </Box>
  );
};

export default PersonalDetails;
